module.exports = __webpack_public_path__ + "img/lion-king.0da24322.jpeg";